module.exports = __webpack_public_path__ + "static/media/logo.07ea4f54.JPG";